import { PaymentService } from '@/services/payments';
import { IncludeApiQueryParam } from '@/types/api';
import { IPaymentWithOrder, IPaymentWithUser } from '@/types/payment';
import { useQueries } from '@tanstack/react-query';

type PaymentWithRelations = IPaymentWithOrder & IPaymentWithUser;

export function useIndividualPayments(
  paymentIds: string[],
  include?: IncludeApiQueryParam,
) {
  const results = useQueries({
    queries: paymentIds.map(id => ({
      queryKey: [PaymentService.PATH, id, include] as const,
      queryFn: () => PaymentService.getPayment(id, include),
    })),
  });

  return {
    data: results
      .map(result => result.data?.data)
      .filter(Boolean) as PaymentWithRelations[],
    isLoading: results.some(result => result.isLoading),
    isError: results.some(result => result.isError),
    error: results.find(result => result.isError)?.error,
    refetch: () => Promise.all(results.map(result => result.refetch())),
  };
}
